import { Pipe, Directive, HostListener, EventEmitter, ElementRef, Input, Output, ViewContainerRef, ComponentFactoryResolver, Component, Inject, PLATFORM_ID, ViewChild, Renderer2, ViewEncapsulation, NgModule } from '@angular/core';
import { isPlatformBrowser, DOCUMENT, CommonModule } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { timer, BehaviorSubject, combineLatest, from } from 'rxjs';
import { filter, tap, map, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { isNullOrUndefined } from 'util';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/pipe/safe.pipe.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SafePipe {
    /**
     * @param {?} sanitizer
     */
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    /**
     * @param {?} value
     * @param {?} args
     * @return {?}
     */
    transform(value, args) {
        switch (args.toLowerCase()) {
            case 'html':
                return this.sanitizer.bypassSecurityTrustHtml(value);
            case 'script':
                return this.sanitizer.bypassSecurityTrustScript(value);
            case 'style':
                return this.sanitizer.bypassSecurityTrustStyle(value);
            case 'url':
                return this.sanitizer.bypassSecurityTrustUrl(value);
            case 'resource':
                return this.sanitizer.bypassSecurityTrustResourceUrl(value);
            default:
                return null;
        }
    }
}
SafePipe.decorators = [
    { type: Pipe, args: [{
                name: 'safe'
            },] }
];
/** @nocollapse */
SafePipe.ctorParameters = () => [
    { type: DomSanitizer }
];
if (false) {
    /**
     * @type {?}
     * @private
     */
    SafePipe.prototype.sanitizer;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/directive/mouseover-scroll.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * 原名: mouseOverScroll
 */
class MouseOverScrollDirective {
    constructor() { }
    /**
     * @param {?} $event
     * @return {?}
     */
    mouseScrollEvent($event) {
        /** @type {?} */
        const currentHeight = $event.clientY;
        // offset height
        /** @type {?} */
        const distance = document.documentElement.scrollTop || document.body.scrollTop;
        // el  height
        /** @type {?} */
        const bottom = document.documentElement.clientHeight;
        if (currentHeight < 30 && $event.which == 1) {
            window.scroll(0, distance - 30);
        }
        else if (bottom - currentHeight < 30 && $event.which == 1) {
            window.scroll(0, distance + 30);
        }
    }
}
MouseOverScrollDirective.decorators = [
    { type: Directive, args: [{
                selector: '[tmMouseOverScroll]',
            },] }
];
/** @nocollapse */
MouseOverScrollDirective.ctorParameters = () => [];
MouseOverScrollDirective.propDecorators = {
    mouseScrollEvent: [{ type: HostListener, args: ['mousemove', ['$event'],] }]
};

/**
 * @fileoverview added by tsickle
 * Generated from: lib/directive/contenteditable-model.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * 原名: techmoreContenteditableModel
 */
class ContenteditableModelDirective {
    /**
     * @param {?} elementRef
     */
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.update = new EventEmitter();
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        if (changes.model.isFirstChange()) {
            this.refreshView();
        }
        else if (changes.model.currentValue !== this.elementRef.nativeElement.innerText) {
            this.refreshView();
        }
    }
    /**
     * @return {?}
     */
    onEdit() {
        /** @type {?} */
        const value = this.elementRef.nativeElement.innerText;
        this.update.emit(value);
    }
    /**
     * @param {?} e
     * @return {?}
     */
    onPaste(e) {
        // tslint:disable-next-line: no-string-literal
        /** @type {?} */
        let paste = (e.clipboardData || window['clipboardData']).getData('text');
        paste = paste.toUpperCase();
        /** @type {?} */
        const textEl = document.createElement('div');
        textEl.innerHTML = paste;
        paste = textEl.innerText;
        /** @type {?} */
        const selection = window.getSelection();
        if (!selection.rangeCount) {
            return false;
        }
        selection.deleteFromDocument();
        selection.getRangeAt(0).insertNode(document.createTextNode(paste));
        e.preventDefault();
    }
    /**
     * @private
     * @return {?}
     */
    refreshView() {
        this.elementRef.nativeElement.textContent = this.model;
    }
}
ContenteditableModelDirective.decorators = [
    { type: Directive, args: [{
                selector: '[tmContenteditableModel]'
            },] }
];
/** @nocollapse */
ContenteditableModelDirective.ctorParameters = () => [
    { type: ElementRef }
];
ContenteditableModelDirective.propDecorators = {
    model: [{ type: Input, args: ['tmContenteditableModel',] }],
    update: [{ type: Output, args: ['tmContenteditableModelChange',] }],
    onEdit: [{ type: HostListener, args: ['blur',] }, { type: HostListener, args: ['keyup',] }],
    onPaste: [{ type: HostListener, args: ['paste', ['$event'],] }]
};
if (false) {
    /** @type {?} */
    ContenteditableModelDirective.prototype.model;
    /** @type {?} */
    ContenteditableModelDirective.prototype.update;
    /**
     * @type {?}
     * @private
     */
    ContenteditableModelDirective.prototype.elementRef;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/directive/component-outlet.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * 原名: techmore-component-outlet
 */
class ComponentOutletDirective {
    /**
     * @param {?} vcRef
     * @param {?} resolver
     */
    constructor(vcRef, resolver) {
        this.vcRef = vcRef;
        this.resolver = resolver;
        // tslint:disable-next-line: no-output-rename
        this.afterRender = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ngOnChanges() {
        if (!this.selector) {
            return;
        }
        /** @type {?} */
        const factories = Array.from(this.resolver['_factories'].values());
        /** @type {?} */
        const factory = factories.find((/**
         * @param {?} x
         * @return {?}
         */
        (x) => x.selector === this.selector));
        /** @type {?} */
        let compRef;
        if (factory) {
            compRef = this.vcRef.createComponent(factory);
        }
        if (this.componentRef) {
            this.componentRef.destroy();
        }
        if (compRef) {
            this.componentRef = compRef;
            this.afterRender.emit(this.componentRef);
        }
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        if (this.componentRef) {
            this.componentRef.destroy();
            this.componentRef = null;
        }
    }
}
ComponentOutletDirective.decorators = [
    { type: Directive, args: [{
                selector: '[tmComponentOutlet]'
            },] }
];
/** @nocollapse */
ComponentOutletDirective.ctorParameters = () => [
    { type: ViewContainerRef },
    { type: ComponentFactoryResolver }
];
ComponentOutletDirective.propDecorators = {
    selector: [{ type: Input, args: ['tmComponentOutlet',] }],
    afterRender: [{ type: Output, args: ['tmComponentOutletAfterRender',] }]
};
if (false) {
    /** @type {?} */
    ComponentOutletDirective.prototype.componentRef;
    /** @type {?} */
    ComponentOutletDirective.prototype.selector;
    /** @type {?} */
    ComponentOutletDirective.prototype.afterRender;
    /**
     * @type {?}
     * @private
     */
    ComponentOutletDirective.prototype.vcRef;
    /**
     * @type {?}
     * @private
     */
    ComponentOutletDirective.prototype.resolver;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/component/recaptcha/recaptcha.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * 原名: techmore-recaptcha
 * Google 驗碼碼套件
 * 需在 app.module 中注入 APP_CONFIG_TOKEN，設定檔中必須提供 recaptchaKey
 */
class RecaptchaComponent {
    /**
     * @param {?} platformId
     */
    constructor(platformId) {
        this.platformId = platformId;
        this.tokenChange = new EventEmitter();
        this.isBrowser = isPlatformBrowser(this.platformId);
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        if (this.isBrowser) {
            this.render();
            window['verified'] = (/**
             * @param {?} response
             * @return {?}
             */
            (response) => this.verified(response));
        }
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        setTimeout((/**
         * @return {?}
         */
        () => {
            /** @type {?} */
            const recaptchaIframe = this.recaptchaTemp.nativeElement.querySelectorAll('iframe');
            if (recaptchaIframe.length > 0) {
                recaptchaIframe[0].setAttribute('title', '機器人驗證');
                recaptchaIframe.forEach((/**
                 * @param {?} item
                 * @param {?} index
                 * @return {?}
                 */
                (item, index) => {
                    if (index > 0) {
                        item.setAttribute('title', '');
                    }
                }));
            }
        }), 500);
    }
    // import google re-captcha api
    /**
     * @private
     * @return {?}
     */
    render() {
        this.siteKey = this.recaptchaKey;
        /** @type {?} */
        const script = document.createElement('script');
        script.src = 'https://www.google.com/recaptcha/api.js?render=${this.siteKey}';
        script.async = true;
        script.defer = true;
        document.body.appendChild(script);
    }
    /**
     * @param {?} response
     * @return {?}
     */
    verified(response) {
        this.tokenChange.emit(response);
    }
    /**
     * @return {?}
     */
    restart() {
        /** @type {?} */
        const myWindow = window;
        myWindow.grecaptcha.reset();
    }
}
RecaptchaComponent.decorators = [
    { type: Component, args: [{
                selector: 'tm-recaptcha',
                template: "<div class=\"g-recaptcha\" [attr.data-sitekey]=\"siteKey\" data-callback=\"verified\" #recaptcha></div>\r\n",
                styles: [""]
            }] }
];
/** @nocollapse */
RecaptchaComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] }
];
RecaptchaComponent.propDecorators = {
    recaptchaTemp: [{ type: ViewChild, args: ['recaptcha', { static: false },] }],
    tokenChange: [{ type: Output }],
    recaptchaKey: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    RecaptchaComponent.prototype.recaptchaTemp;
    /** @type {?} */
    RecaptchaComponent.prototype.siteKey;
    /** @type {?} */
    RecaptchaComponent.prototype.tokenChange;
    /** @type {?} */
    RecaptchaComponent.prototype.recaptchaKey;
    /**
     * 是否渲染端為瀏覽器
     * @type {?}
     * @protected
     */
    RecaptchaComponent.prototype.isBrowser;
    /**
     * @type {?}
     * @protected
     */
    RecaptchaComponent.prototype.platformId;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/directive/off-canvas-btn.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * 後台切換畫面用的，現在是分成左右兩個區塊，左右移動去切換內頁和選單列表
 * 原名: offCanvasBtn
 */
class OffCanvasBtnDirective {
    /**
     * @param {?} el
     */
    constructor(el) {
        this.el = el;
    }
    /**
     * @param {?} evt
     * @return {?}
     */
    toggleSlider(evt) {
        /** @type {?} */
        const target = document.getElementsByClassName('row-offcanvas')[0];
        if (target.classList.contains('active')) {
            target.classList.remove('active');
        }
        else {
            target.classList.add('active');
        }
    }
}
OffCanvasBtnDirective.decorators = [
    { type: Directive, args: [{
                selector: '[tmOffCanvasBtn]'
            },] }
];
/** @nocollapse */
OffCanvasBtnDirective.ctorParameters = () => [
    { type: ElementRef }
];
OffCanvasBtnDirective.propDecorators = {
    toggleSlider: [{ type: HostListener, args: ['click', ['$event'],] }]
};
if (false) {
    /**
     * @type {?}
     * @private
     */
    OffCanvasBtnDirective.prototype.el;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/directive/error-default-image.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * 原名: errorDefaultImage
 */
class ErrorDefaultImageDirective {
    /**
     * @param {?} elementRef
     */
    constructor(elementRef) {
        this.elementRef = elementRef;
        // tslint:disable-next-line: no-input-rename
        this.imageSrc = '';
        this.picError = new EventEmitter();
    }
    /**
     * @param {?} $event
     * @return {?}
     */
    onClick($event) {
        this.elementRef.nativeElement.src = this.imageSrc;
        this.picError.emit(true);
    }
}
ErrorDefaultImageDirective.decorators = [
    { type: Directive, args: [{
                selector: 'img[tmErrorDefaultImage]'
            },] }
];
/** @nocollapse */
ErrorDefaultImageDirective.ctorParameters = () => [
    { type: ElementRef }
];
ErrorDefaultImageDirective.propDecorators = {
    imageSrc: [{ type: Input, args: ['tmErrorDefaultImage',] }],
    picError: [{ type: Output }],
    onClick: [{ type: HostListener, args: ['error', ['$event'],] }]
};
if (false) {
    /** @type {?} */
    ErrorDefaultImageDirective.prototype.imageSrc;
    /** @type {?} */
    ErrorDefaultImageDirective.prototype.picError;
    /**
     * @type {?}
     * @private
     */
    ErrorDefaultImageDirective.prototype.elementRef;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/directive/font-adjust.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * 原名: FontAdjust
 */
class FontAdjustDirective {
    /**
     * @param {?} platformId
     * @param {?} el
     * @param {?} rend
     */
    constructor(platformId, el, rend) {
        this.platformId = platformId;
        this.rend = rend;
        this.currentRatio = 100;
        this.isBrowser = isPlatformBrowser(this.platformId);
        this.node = el.nativeElement;
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        if (this.isBrowser) {
            if (this.fontSize > 0) {
                this.rend.listen(this.node, 'click', this.growFontSize.bind(this));
            }
            else {
                this.rend.listen(this.node, 'click', this.shrinkFontSize.bind(this));
            }
        }
    }
    /**
     * @param {?} el
     * @param {?} cb
     * @return {?}
     */
    walkChilds(el, cb) {
        /** @type {?} */
        const childs = el.children;
        for (let i = 0; i < childs.length; i++) {
            if (childs[i].tagName && childs[i].tagName !== 'undefined') {
                cb((/** @type {?} */ (childs[i])));
                this.walkChilds((/** @type {?} */ (childs[i])), cb);
            }
        }
    }
    /**
     * @return {?}
     */
    transformFontSize() {
        // 紀錄外層元素原本的字體大小
        /** @type {?} */
        const contentOriFontSize = parseFloat(window.getComputedStyle(this.content).getPropertyValue('font-size'));
        // 紀錄子元素原本的字體大小
        this.walkChilds(this.content, (/**
         * @param {?} el
         * @return {?}
         */
        (el) => {
            /** @type {?} */
            const fs = parseFloat(window.getComputedStyle(el).getPropertyValue('font-size'));
            ((/** @type {?} */ (el))).dataset.oriFontSize = `${fs}`;
        }));
        // 計算新外層元素字體大小
        /** @type {?} */
        const contentNewFontSize = (contentOriFontSize * (this.currentRatio + this.fontSize)) / 100;
        this.content.style.fontSize = contentNewFontSize + 'px';
        // 計算新子元素字體大小
        this.walkChilds(this.content, (/**
         * @param {?} el
         * @return {?}
         */
        (el) => {
            /** @type {?} */
            const fs = parseFloat(window.getComputedStyle(el).getPropertyValue('font-size'));
            /** @type {?} */
            const oriFs = +((/** @type {?} */ (el))).dataset.oriFontSize;
            /** @type {?} */
            const isFontSizeInherit = ((/** @type {?} */ (el))).dataset
                .fontSizeInherit;
            if (undefined === isFontSizeInherit) {
                // 標記子元素是否是繼承上層元素的字體大小(繼承的就不手動更改字體大小)
                if (oriFs === contentOriFontSize && fs === contentNewFontSize) {
                    ((/** @type {?} */ (el))).dataset.fontSizeInherit = `true`;
                }
                else {
                    ((/** @type {?} */ (el))).dataset.fontSizeInherit = `false`;
                    ((/** @type {?} */ (el))).style.fontSize =
                        (oriFs * (this.currentRatio + this.fontSize)) / 100 + 'px';
                }
            }
            else {
                if (isFontSizeInherit === 'false') {
                    ((/** @type {?} */ (el))).style.fontSize =
                        (oriFs * (this.currentRatio + this.fontSize)) / 100 + 'px';
                }
            }
        }));
    }
    /**
     * @param {?} evt
     * @return {?}
     */
    growFontSize(evt) {
        evt.preventDefault();
        this.transformFontSize();
    }
    /**
     * @param {?} evt
     * @return {?}
     */
    shrinkFontSize(evt) {
        evt.preventDefault();
        this.transformFontSize();
    }
}
FontAdjustDirective.decorators = [
    { type: Directive, args: [{
                selector: '[tmFontAdjust]',
            },] }
];
/** @nocollapse */
FontAdjustDirective.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] },
    { type: ElementRef },
    { type: Renderer2 }
];
FontAdjustDirective.propDecorators = {
    fontSize: [{ type: Input }],
    content: [{ type: Input }]
};
if (false) {
    /**
     * 是否渲染端為瀏覽器
     * @type {?}
     * @protected
     */
    FontAdjustDirective.prototype.isBrowser;
    /** @type {?} */
    FontAdjustDirective.prototype.fontSize;
    /** @type {?} */
    FontAdjustDirective.prototype.content;
    /** @type {?} */
    FontAdjustDirective.prototype.node;
    /** @type {?} */
    FontAdjustDirective.prototype.currentRatio;
    /**
     * @type {?}
     * @protected
     */
    FontAdjustDirective.prototype.platformId;
    /**
     * @type {?}
     * @private
     */
    FontAdjustDirective.prototype.rend;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/directive/object-fit.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * 原名: objectFit
 */
class ObjectFitDirective {
    /**
     * @param {?} platformId
     * @param {?} elementRef
     */
    constructor(platformId, elementRef) {
        this.platformId = platformId;
        this.elementRef = elementRef;
        this._fitType = 'cover';
        this.isSupportObjectFit = 'objectFit' in document.documentElement.style;
        this.isInit = false;
        this.errorImgSrc = '';
        this._imgSrc = '';
        this.isBrowser = isPlatformBrowser(this.platformId);
    }
    // tslint:disable-next-line: no-input-rename
    /**
     * @param {?} type
     * @return {?}
     */
    set fitType(type) {
        if (type) {
            this._fitType = type;
            this.changeFillType();
        }
    }
    /**
     * @return {?}
     */
    get fitType() { return this._fitType; }
    /**
     * @param {?} src
     * @return {?}
     */
    set imgSrc(src) {
        this._imgSrc = src;
        if (this.isInit) {
            this.setImageSrc(this.imgSrc ? this.imgSrc : this.errorImgSrc);
        }
    }
    ;
    /**
     * @return {?}
     */
    get imgSrc() { return this._imgSrc; }
    /**
     * @return {?}
     */
    ngOnInit() {
        if (this.isBrowser) {
            if (!this.isSupportObjectFit) {
                /** @type {?} */
                let dom = this.elementRef.nativeElement;
                /** @type {?} */
                const parent = dom.parentElement;
                /** @type {?} */
                const container = document.createElement('div');
                parent.insertBefore(container, dom);
                dom = parent.removeChild(dom);
                container.appendChild(dom);
                this.isInit = true;
            }
            this.setImageSrc(this.imgSrc ? this.imgSrc : this.errorImgSrc);
        }
    }
    /**
     * @param {?} src
     * @return {?}
     */
    setImageSrc(src) {
        /** @type {?} */
        const dom = this.elementRef.nativeElement;
        /** @type {?} */
        const container = dom.parentElement;
        if (!this.isSupportObjectFit) {
            dom.style.opacity = 0;
            container.style.height = '100%';
            container.style.backgroundSize = this.objectFit2backgroundSize(this.fitType);
            container.style.backgroundImage = 'url("' + encodeURI(src) + '")';
            container.style.backgroundPosition = 'center center';
        }
        else {
            dom.style.objectFit = this.fitType;
        }
        dom.src = src;
    }
    /**
     * @param {?} t
     * @return {?}
     */
    objectFit2backgroundSize(t) {
        switch (t) {
            case 'fill':
                return '100% 100%';
            case 'contain':
                return 'contain';
            case 'cover':
                return 'cover';
            case 'scale-down':
                return 'initial';
        }
    }
    /**
     * @return {?}
     */
    changeFillType() {
        /** @type {?} */
        const dom = this.elementRef.nativeElement;
        /** @type {?} */
        const container = dom.parentElement;
        if (!this.isSupportObjectFit) {
            container.style.backgroundSize = this.objectFit2backgroundSize(this.fitType);
        }
        else {
            dom.style.objectFit = this.fitType;
        }
    }
}
ObjectFitDirective.decorators = [
    { type: Directive, args: [{
                selector: 'img[tmObjectFit]'
            },] }
];
/** @nocollapse */
ObjectFitDirective.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] },
    { type: ElementRef }
];
ObjectFitDirective.propDecorators = {
    fitType: [{ type: Input, args: ['tmObjectFit',] }],
    errorImgSrc: [{ type: Input, args: ['tmErrorDefaultImage',] }],
    imgSrc: [{ type: Input }]
};
if (false) {
    /**
     * @type {?}
     * @private
     */
    ObjectFitDirective.prototype._fitType;
    /** @type {?} */
    ObjectFitDirective.prototype.isSupportObjectFit;
    /** @type {?} */
    ObjectFitDirective.prototype.isInit;
    /** @type {?} */
    ObjectFitDirective.prototype.errorImgSrc;
    /** @type {?} */
    ObjectFitDirective.prototype._imgSrc;
    /**
     * 是否渲染端為瀏覽器
     * @type {?}
     * @protected
     */
    ObjectFitDirective.prototype.isBrowser;
    /**
     * @type {?}
     * @protected
     */
    ObjectFitDirective.prototype.platformId;
    /**
     * @type {?}
     * @protected
     */
    ObjectFitDirective.prototype.elementRef;
    /* Skipping unhandled member: ;*/
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/directive/printer.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * 列印成 pdf，支援 iframe 內容列印
 * 原名: printer
 * about print, should apply ...
 * https://medium.com/unalai/%E5%8E%9F%E4%BE%86%E5%89%8D%E7%AB%AF%E7%B6%B2%E9%A0%81%E5%88%97%E5%8D%B0-%E4%B8%8D%E6%98%AF%E5%8F%AA%E8%A6%81-window-print-%E5%B0%B1%E5%A5%BD%E4%BA%86-7af44cacf43e
 */
class PrinterDirective {
    /**
     * @param {?} platformId
     * @param {?} el
     * @param {?} rend
     */
    constructor(platformId, el, rend) {
        this.platformId = platformId;
        this.el = el;
        this.rend = rend;
        this.hasInitFrameContent = false;
        this.isBrowser = isPlatformBrowser(this.platformId);
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        if (this.isBrowser) {
            this.rend.listen(this.el.nativeElement, 'click', this.friendlyPrint.bind(this));
        }
    }
    // @HostListener('click', ['$event']) //偵測事件
    /**
     * @param {?} evt
     * @return {?}
     */
    friendlyPrint(evt) {
        evt.preventDefault();
        this.hasInitFrameContent = false; // 每次點選要重初始化
        // 每次點選要重初始化
        /** @type {?} */
        let printContents;
        /** @type {?} */
        let popupWin;
        /** @type {?} */
        const targetDom = this.doc;
        // 取出所有 iframe 內 html
        /** @type {?} */
        const ifrmContents = [];
        /** @type {?} */
        const ifrms = targetDom.querySelectorAll('iframe');
        // tslint:disable-next-line: prefer-for-of
        for (let i = 0; i < ifrms.length; i++) {
            /** @type {?} */
            const ifrm = (/** @type {?} */ (ifrms[i]));
            try {
                if (ifrm.classList.contains('noPrint')) {
                    ifrmContents.push('');
                }
                else {
                    ifrmContents.push(`${ifrm.contentWindow.document.head.outerHTML}
          ${ifrm.contentWindow.document.body.outerHTML}`);
                }
            }
            catch (error) {
                // cors 限制的 iframe 就打印個 src 位址
                ifrmContents.push(`tmSrc:${ifrm.src}`);
            }
        }
        printContents = targetDom.innerHTML;
        /** @type {?} */
        const isFireFox = navigator.userAgent.indexOf('Firefox') > -1;
        if (isFireFox) {
            popupWin = window.open('about:blank', '_blank', `top=0,left=0,height=${window.innerHeight},width=${window.innerWidth}`);
        }
        else {
            popupWin = window.open('', '_blank', `top=0,left=0,height=${window.innerHeight},width=auto`);
        }
        popupWin.document.write(`
      <html>
        <head>
          <title>友善列印</title>
          <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css">
          <style>
            @page {
              margin: 0.5cm;
              margin-bottom: 1cm;
            }

            body > * {
                margin: 0;
                padding: 0;
            }

            body {
                font: 12pt "微軟正黑體", Microsoft JhengHei, "Times New Roman", Times, serif;
                line-height: 1.3;
            }

            article > h1 {
                font-size: 2em;
                line-height: 0.8em;
            }

            article > time {
                font-size: 0.8em;
            }

            article figure {
                display: inline-block;
                max-width: 280px;
            }
            article li a{
                text-decoration: none;
            }
            @media print {
              * {
                -webkit-print-color-adjust: exact !important;
              }
              .noBreak {
                break-inside: avoid;
              }
              .noPrint {
                display: none;
              }
            }
          </style>
          <script type="text/javascript">
            function handleLoad() {
              if (window['copyIframeContent']) {
                window['copyIframeContent']();
              }
              window.print();
              window.close();
            }

            window.addEventListener('load', function () {
              handleLoad();
            }, false);
          </script>
        </head>
        <body onload="handleLoad();">${printContents}</body>
        <script type="text/javascript">
          handleLoad();
        </script>
      </html>`);
        if (ifrmContents.length > 0 && !this.hasInitFrameContent) {
            this.copyIframeContent(ifrmContents, popupWin);
            if (!this.hasInitFrameContent) {
                popupWin['copyIframeContent'] = (/**
                 * @return {?}
                 */
                () => {
                    this.copyIframeContent(ifrmContents, popupWin);
                });
            }
        }
        popupWin.document.close();
    }
    /**
     * @param {?} ifrmContents
     * @param {?} wind
     * @return {?}
     */
    copyIframeContent(ifrmContents, wind) {
        // tslint:disable-next-line: max-line-length
        /** @type {?} */
        const ifrmsCl = (/** @type {?} */ (wind.document.getElementsByTagName('iframe')));
        if (ifrmsCl.length === ifrmContents.length) {
            this.hasInitFrameContent = true;
            for (let i = 0; i < ifrmsCl.length; i++) {
                if (ifrmContents[i].startsWith('tmSrc')) {
                    /** @type {?} */
                    const ifrmSrc = ifrmContents[i].replace('tmSrc:', '');
                    /** @type {?} */
                    const p = document.createElement('p');
                    p.innerHTML = `(url: ${ifrmSrc})`;
                    ifrmsCl[i].parentNode.insertBefore(p, ifrmsCl[i].nextSibling);
                }
                else if (ifrmContents[i]) {
                    ifrmsCl[i].contentWindow.document.write(ifrmContents[i]);
                }
            }
        }
    }
}
PrinterDirective.decorators = [
    { type: Directive, args: [{
                selector: '[tmPrinter]'
            },] }
];
/** @nocollapse */
PrinterDirective.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] },
    { type: ElementRef },
    { type: Renderer2 }
];
PrinterDirective.propDecorators = {
    doc: [{ type: Input, args: ['tmPrinter',] }]
};
if (false) {
    /** @type {?} */
    PrinterDirective.prototype.doc;
    /** @type {?} */
    PrinterDirective.prototype.hasInitFrameContent;
    /**
     * 是否渲染端為瀏覽器
     * @type {?}
     * @protected
     */
    PrinterDirective.prototype.isBrowser;
    /**
     * @type {?}
     * @protected
     */
    PrinterDirective.prototype.platformId;
    /**
     * @type {?}
     * @private
     */
    PrinterDirective.prototype.el;
    /**
     * @type {?}
     * @private
     */
    PrinterDirective.prototype.rend;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/directive/share-facebook.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * 原名: shareFacebook
 */
class ShareFacebookDirective {
    /**
     * @param {?} document
     * @param {?} el
     * @param {?} rend
     * @param {?} platformId
     */
    constructor(document, el, rend, platformId) {
        this.document = document;
        this.el = el;
        this.rend = rend;
        this.platformId = platformId;
        this.open = new EventEmitter();
        this.node = el.nativeElement;
        this.isBrowser = isPlatformBrowser(this.platformId);
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        if (this.isBrowser) {
            this.rend.listen(this.node, 'click', this.onClick.bind(this));
        }
    }
    /**
     * @param {?} $event
     * @return {?}
     */
    onClick($event) {
        if (!this.shareUrl) {
            this.shareUrl = this.document.location.href;
        }
        this.open.emit();
        window.open('http://www.facebook.com/sharer.php?u='.concat(encodeURIComponent(this.shareUrl)), '_blank', 'height=500,resizable=yes,scrollbars=yes,width=700');
    }
}
ShareFacebookDirective.decorators = [
    { type: Directive, args: [{
                selector: '[tmShareFacebook]'
            },] }
];
/** @nocollapse */
ShareFacebookDirective.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
    { type: ElementRef },
    { type: Renderer2 },
    { type: undefined, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] }
];
ShareFacebookDirective.propDecorators = {
    shareUrl: [{ type: Input }],
    open: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    ShareFacebookDirective.prototype.shareUrl;
    /** @type {?} */
    ShareFacebookDirective.prototype.open;
    /** @type {?} */
    ShareFacebookDirective.prototype.node;
    /**
     * 是否渲染端為瀏覽器
     * @type {?}
     * @protected
     */
    ShareFacebookDirective.prototype.isBrowser;
    /**
     * @type {?}
     * @private
     */
    ShareFacebookDirective.prototype.document;
    /**
     * @type {?}
     * @private
     */
    ShareFacebookDirective.prototype.el;
    /**
     * @type {?}
     * @private
     */
    ShareFacebookDirective.prototype.rend;
    /**
     * @type {?}
     * @protected
     */
    ShareFacebookDirective.prototype.platformId;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/directive/share-line.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * 原名: shareLine
 */
class ShareLineDirective {
    /**
     * @param {?} document
     * @param {?} el
     * @param {?} rend
     * @param {?} platformId
     */
    constructor(document, el, rend, platformId) {
        this.document = document;
        this.el = el;
        this.rend = rend;
        this.platformId = platformId;
        this.open = new EventEmitter();
        this.node = el.nativeElement;
        this.isBrowser = isPlatformBrowser(this.platformId);
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        if (this.isBrowser) {
            this.rend.listen(this.node, 'click', this.onClick.bind(this));
        }
    }
    /**
     * @param {?} $event
     * @return {?}
     */
    onClick($event) {
        /** @type {?} */
        let url = null;
        if (!this.shareUrl) {
            url = this.document.location.href;
        }
        else {
            url = this.shareUrl;
        }
        this.open.emit();
        window.open(this.getShareUrl(url), '_blank', 'height=500,resizable=yes,scrollbars=yes,width=700');
    }
    /**
     * @param {?} url
     * @return {?}
     */
    getShareUrl(url) {
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            return 'http://line.naver.jp/R/msg/text/?'.concat(encodeURIComponent(url));
        }
        else { // 網頁版語法
            return 'https://lineit.line.me/share/ui?url=' + encodeURIComponent(url);
        }
    }
}
ShareLineDirective.decorators = [
    { type: Directive, args: [{
                selector: '[tmShareLine]'
            },] }
];
/** @nocollapse */
ShareLineDirective.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
    { type: ElementRef },
    { type: Renderer2 },
    { type: undefined, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] }
];
ShareLineDirective.propDecorators = {
    shareUrl: [{ type: Input }],
    open: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    ShareLineDirective.prototype.shareUrl;
    /** @type {?} */
    ShareLineDirective.prototype.open;
    /** @type {?} */
    ShareLineDirective.prototype.node;
    /**
     * 是否渲染端為瀏覽器
     * @type {?}
     * @protected
     */
    ShareLineDirective.prototype.isBrowser;
    /**
     * @type {?}
     * @private
     */
    ShareLineDirective.prototype.document;
    /**
     * @type {?}
     * @private
     */
    ShareLineDirective.prototype.el;
    /**
     * @type {?}
     * @private
     */
    ShareLineDirective.prototype.rend;
    /**
     * @type {?}
     * @protected
     */
    ShareLineDirective.prototype.platformId;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/directive/share-twitter.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * 原名: shareTwitter
 */
class ShareTwitterDirective {
    /**
     * @param {?} document
     * @param {?} el
     * @param {?} rend
     * @param {?} platformId
     */
    constructor(document, el, rend, platformId) {
        this.document = document;
        this.el = el;
        this.rend = rend;
        this.platformId = platformId;
        this.open = new EventEmitter();
        this.node = el.nativeElement;
        this.isBrowser = isPlatformBrowser(this.platformId);
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        if (this.isBrowser) {
            this.rend.listen(this.node, 'click', this.onClick.bind(this));
        }
    }
    /**
     * @param {?} $event
     * @return {?}
     */
    onClick($event) {
        if (!this.shareUrl) {
            this.shareUrl = this.document.location.href;
        }
        this.open.emit();
        window.open('https://twitter.com/intent/tweet?url='.concat(encodeURIComponent(this.shareUrl)), '_blank', 'height=500,resizable=yes,scrollbars=yes,width=700');
    }
}
ShareTwitterDirective.decorators = [
    { type: Directive, args: [{
                selector: '[tmShareTwitter]'
            },] }
];
/** @nocollapse */
ShareTwitterDirective.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
    { type: ElementRef },
    { type: Renderer2 },
    { type: undefined, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] }
];
ShareTwitterDirective.propDecorators = {
    shareUrl: [{ type: Input }],
    open: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    ShareTwitterDirective.prototype.shareUrl;
    /** @type {?} */
    ShareTwitterDirective.prototype.open;
    /** @type {?} */
    ShareTwitterDirective.prototype.node;
    /**
     * 是否渲染端為瀏覽器
     * @type {?}
     * @protected
     */
    ShareTwitterDirective.prototype.isBrowser;
    /**
     * @type {?}
     * @private
     */
    ShareTwitterDirective.prototype.document;
    /**
     * @type {?}
     * @private
     */
    ShareTwitterDirective.prototype.el;
    /**
     * @type {?}
     * @private
     */
    ShareTwitterDirective.prototype.rend;
    /**
     * @type {?}
     * @protected
     */
    ShareTwitterDirective.prototype.platformId;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/directive/text-ellipsis.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * 原名: textEllipsis
 */
class TextEllipsisDirective {
    /**
     * @param {?} el
     * @param {?} render
     * @param {?} platformId
     */
    constructor(el, render, platformId) {
        this.el = el;
        this.render = render;
        this.platformId = platformId;
        this.allowOverflowWordsCnt = 0;
        this.isPureTextDom = true;
        this.isBrowser = isPlatformBrowser(this.platformId);
        if (this.isBrowser && typeof MutationObserver !== 'undefined') {
            this.changes = new MutationObserver((/**
             * @param {?} mutations
             * @return {?}
             */
            (mutations) => {
                this.cancelObserveDomChange();
                this.ellipseText();
                this.startObserveDomChange();
            }));
        }
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        if (this.isBrowser) {
            this.ellipseText();
            this.startObserveDomChange();
        }
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.cancelObserveDomChange();
    }
    /**
     * @return {?}
     */
    startObserveDomChange() {
        if (this.changes) {
            this.changes.observe(this.el.nativeElement, {
                attributes: true,
                childList: true,
                characterData: true
            });
        }
    }
    /**
     * @return {?}
     */
    cancelObserveDomChange() {
        if (this.changes) {
            this.changes.disconnect();
        }
    }
    /**
     * @return {?}
     */
    ellipseText() {
        if (this.ellipsisType === 'multi') {
            this.multipleTextEllipsis();
        }
        else {
            this.allowOverflowWordsCnt = 0;
        }
        if (this.postCss) {
            /** @type {?} */
            const cssKeys = Object.keys(this.postCss);
            if (cssKeys.length > 0) {
                cssKeys.forEach((/**
                 * @param {?} val
                 * @return {?}
                 */
                (val) => {
                    this.render.setStyle(this.el.nativeElement, val, this.postCss[val]);
                }));
            }
        }
        this.destoryCloneElement();
    }
    /**
     * 多行文本的刪節號處理
     * @return {?}
     */
    multipleTextEllipsis() {
        this.cloneElement();
        this.isPureTextDom = this.checkDomIsPureText((/** @type {?} */ (this.cloneDOM)));
        this.walkAndCutChilds((/** @type {?} */ (this.cloneDOM)));
        this.el.nativeElement.innerHTML = this.cloneDOM['innerHTML'];
    }
    /**
     * (多行文本適用)
     * 遍歷節點樹並刪除所有多餘的節點、葉節點漢文本內容
     * @param {?} dom 節點對象
     * @return {?} true: 已刪減完畢可直接結束遍歷；false: 此節點下的內容都是多餘，包含該節點所有內容都已被移除
     */
    walkAndCutChilds(dom) {
        /** @type {?} */
        const childs = this.getChildNodesNoComment(dom);
        // 走訪所有子節點，若為葉子則對內容做刪減，若為枝子則往下層繼續走
        for (let i = childs.length - 1; i >= 0; i--) {
            if (this.getChildNodesNoComment(childs[i]).length > 0) {
                if (this.walkAndCutChilds(childs[i])) {
                    return true;
                }
            }
            else {
                if (this.quizDom(childs[i])) {
                    return true;
                }
            }
        }
        // 走訪完所有子節點，節點為空(沒有子節點)時就移除自己
        if (dom.textContent.trim().length === 0) {
            dom.parentNode.removeChild(dom);
        }
        return false;
    }
    /**
     * 對節點對象的文字內容做刪減直到高度符合樣式表的期待高度，
     * 若內文刪減至空字串則移除該節點，若有剩餘文字則加上刪節號並結束所有遍歷
     * @param {?} dom 節點對象
     * @return {?} true: 內文刪減完畢可直接結束遍歷；false: 該節點刪減至空已被移除
     */
    quizDom(dom) {
        /** @type {?} */
        let content = dom.textContent;
        /** @type {?} */
        let hasRoughCut = false;
        /** @type {?} */
        let hasFineCut = false;
        this.exactOffsetHeight = this.el.nativeElement.offsetHeight;
        /**
         * 先找出全部內容高度 及 單行高度  計算數大約每行字數有多少
         * 然後再依據需求高度 跟單行高度算數 大約需要多少個字
         * 超過再由原先的程式去刪減他 減少需要跑大量迴圈來刪減字數
         */
        if (this.isPureTextDom) {
            if (content.length > 0 && this.isOverHeight()) {
                hasRoughCut = true;
                /** @type {?} */
                const allContentHeight = this.cloneDOM['offsetHeight'];
                dom.textContent = ' ';
                /** @type {?} */
                const padding = this.cloneDOM['offsetHeight'];
                dom.textContent = 'T';
                /** @type {?} */
                const oneLineHeight = this.cloneDOM['offsetHeight'] - padding;
                this.calExactOffsetHeight(oneLineHeight, this.el.nativeElement.offsetHeight);
                content = content.substr(0, Math.ceil(content.length * (this.exactOffsetHeight + oneLineHeight) / allContentHeight));
                dom.textContent = content;
            }
        }
        while (content.length > 0 && this.isOverHeight()) {
            content = content.substr(0, content.length - 1);
            dom.textContent = content;
            hasFineCut = true;
        }
        if (content.length > 0) {
            if (hasRoughCut) { // also isPureTextDom == true
                this.allowOverflowWordsCnt = +this.allowOverflowWordsCnt;
                if (this.allowOverflowWordsCnt) {
                    /** @type {?} */
                    let startPoint;
                    /** @type {?} */
                    let endPoint;
                    if (this.allowOverflowWordsCnt > 0) {
                        startPoint = content.length;
                        endPoint = startPoint + this.allowOverflowWordsCnt + 3;
                        if (endPoint > this.el.nativeElement.innerHTML.length) {
                            endPoint = this.el.nativeElement.innerHTML.length;
                        }
                        content = content + this.el.nativeElement.innerHTML.substring(startPoint, endPoint);
                    }
                    else { // < 0
                        endPoint = content.length + this.allowOverflowWordsCnt + 3;
                        if (endPoint < 0) {
                            endPoint = 0;
                        }
                        content = content.substr(0, endPoint);
                    }
                } // end if allowOverflowWordsCnt set
            } // end if PureTextDom hasRoughCut
            if (hasRoughCut || hasFineCut) {
                content = content.substr(0, content.length - 3);
                if (content.length > 0) {
                    dom.textContent = content + '...';
                }
            }
            return true;
        }
        else {
            dom.parentNode.removeChild(dom);
            return false;
        }
    }
    /**
     * 取得所有子節點且非註釋節點
     * @param {?} dom 節點對象
     * @return {?}
     */
    getChildNodesNoComment(dom) {
        /** @type {?} */
        const childs = dom.childNodes;
        /** @type {?} */
        const ret = [];
        for (let i = 0; i < childs.length; i++) {
            if (childs[i].nodeName !== '#comment') {
                ret.push(childs[i]);
            }
        }
        return ret;
    }
    /**
     * 檢查節點為純文字節點 (即節點只能包含文本節點和註釋節點)
     * @param {?} dom 節點對象
     * @return {?}
     */
    checkDomIsPureText(dom) {
        /** @type {?} */
        const childs = dom.childNodes;
        for (let i = 0; i < childs.length; i++) {
            if (childs[i].nodeName !== '#comment' && childs[i].nodeName !== '#text') {
                return false;
            }
        }
        return true;
    }
    /**
     * 計算實際運算用高度
     * @param {?} lineHeight 目標dom物件單行高度
     * @param {?} offsetHeight 目標dom物件原始高度
     * @return {?}
     */
    calExactOffsetHeight(lineHeight, offsetHeight) {
        /** @type {?} */
        const lineCount = Math.ceil(offsetHeight / lineHeight);
        this.exactOffsetHeight = lineCount * lineHeight;
    }
    /**
     * @return {?}
     */
    cloneElement() {
        this.cloneDOM = this.el.nativeElement.cloneNode(true);
        this.render.setStyle(this.cloneDOM, 'position', 'absolute');
        this.render.setStyle(this.cloneDOM, 'opacity', 0);
        this.render.setStyle(this.cloneDOM, 'overflow', 'visible');
        this.render.setStyle(this.cloneDOM, 'visibility', 'hidden');
        this.render.setStyle(this.cloneDOM, 'width', this.el.nativeElement.clientWidth + 'px');
        this.render.setStyle(this.cloneDOM, 'height', 'auto');
        this.render.appendChild(this.el.nativeElement.parentElement, this.cloneDOM);
    }
    /**
     * @return {?}
     */
    isOverHeight() {
        return this.cloneDOM['offsetHeight'] > this.exactOffsetHeight;
    }
    /**
     * @return {?}
     */
    getWidth() {
    }
    /**
     * @return {?}
     */
    destoryCloneElement() {
        this.render.removeChild(this.cloneDOM['parentElement'], this.cloneDOM);
    }
}
TextEllipsisDirective.decorators = [
    { type: Directive, args: [{
                selector: '[tmTextEllipsis]',
                exportAs: 'textEllipsis'
            },] }
];
/** @nocollapse */
TextEllipsisDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 },
    { type: undefined, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] }
];
TextEllipsisDirective.propDecorators = {
    ellipsisType: [{ type: Input, args: ['tmTextEllipsis',] }],
    allowOverflowWordsCnt: [{ type: Input }],
    postCss: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    TextEllipsisDirective.prototype.ellipsisType;
    /** @type {?} */
    TextEllipsisDirective.prototype.allowOverflowWordsCnt;
    /** @type {?} */
    TextEllipsisDirective.prototype.postCss;
    /** @type {?} */
    TextEllipsisDirective.prototype.cloneDOM;
    /** @type {?} */
    TextEllipsisDirective.prototype.isPureTextDom;
    /**
     * @type {?}
     * @private
     */
    TextEllipsisDirective.prototype.changes;
    /**
     * @type {?}
     * @private
     */
    TextEllipsisDirective.prototype.exactOffsetHeight;
    /**
     * 是否渲染端為瀏覽器
     * @type {?}
     * @protected
     */
    TextEllipsisDirective.prototype.isBrowser;
    /**
     * @type {?}
     * @private
     */
    TextEllipsisDirective.prototype.el;
    /**
     * @type {?}
     * @private
     */
    TextEllipsisDirective.prototype.render;
    /**
     * @type {?}
     * @protected
     */
    TextEllipsisDirective.prototype.platformId;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/directive/google-search-box.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * 原名: GoogleSearchBox
 */
class GoogleSearchBoxDirective {
    /**
     * @param {?} platformId
     * @param {?} element
     */
    constructor(platformId, element) {
        this.platformId = platformId;
        this.element = element;
        this.attributes = {};
        this.gname = 'googleCustomSearch';
        this.isBrowser = isPlatformBrowser(this.platformId);
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        if (this.isBrowser) {
            this.googleListenerSubscription = timer(0, 500).pipe(filter((/**
             * @param {?} t
             * @return {?}
             */
            t => 'google' in window && 'search' in google && 'cse' in google.search && 'element' in google.search.cse))).subscribe((/**
             * @return {?}
             */
            () => {
                // 利用render 產生google custom search 查詢元件
                // tslint:disable-next-line: max-line-length
                google.search.cse.element.render({ div: this.element.nativeElement, tag: 'searchbox', gname: this.gname, attributes: this.attributes }, { div: this.searchResults, tag: 'searchresults', gname: this.gname, attributes: this.attributes });
                this.googleListenerSubscription.unsubscribe();
            }));
        }
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        if (this.googleListenerSubscription) {
            this.googleListenerSubscription.unsubscribe();
        }
    }
}
GoogleSearchBoxDirective.decorators = [
    { type: Directive, args: [{
                selector: '[tmGoogleSearchBox]'
            },] }
];
/** @nocollapse */
GoogleSearchBoxDirective.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] },
    { type: ElementRef }
];
GoogleSearchBoxDirective.propDecorators = {
    attributes: [{ type: Input }],
    gname: [{ type: Input }],
    searchResults: [{ type: Input }]
};
if (false) {
    /**
     * 是否渲染端為瀏覽器
     * @type {?}
     * @protected
     */
    GoogleSearchBoxDirective.prototype.isBrowser;
    /** @type {?} */
    GoogleSearchBoxDirective.prototype.googleListenerSubscription;
    /** @type {?} */
    GoogleSearchBoxDirective.prototype.attributes;
    /** @type {?} */
    GoogleSearchBoxDirective.prototype.gname;
    /** @type {?} */
    GoogleSearchBoxDirective.prototype.searchResults;
    /**
     * @type {?}
     * @protected
     */
    GoogleSearchBoxDirective.prototype.platformId;
    /**
     * @type {?}
     * @private
     */
    GoogleSearchBoxDirective.prototype.element;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/directive/google-search-results-only.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * 原名: GoogleSearchResultsOnly
 */
class GoogleSearchResultsOnlyDirective {
    /**
     * @param {?} platformId
     * @param {?} element
     */
    constructor(platformId, element) {
        this.platformId = platformId;
        this.element = element;
        this.googleElement = new BehaviorSubject(null);
        this._query = new BehaviorSubject(null);
        this.attributes = {};
        this.googleTag = 'searchresults-only';
        this.gname = 'googleCustomSearch';
        this.isBrowser = isPlatformBrowser(this.platformId);
    }
    /**
     * @return {?}
     */
    get query() {
        return this._query.getValue();
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set query(value) {
        this._query.next(value);
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        if (this.isBrowser) {
            this.googleListenerSubscription = timer(0, 500).pipe(filter((/**
             * @param {?} t
             * @return {?}
             */
            t => 'google' in window && 'search' in google && 'cse' in google.search && 'element' in google.search.cse)), 
            // 利用render 產生google custom search 查詢元件
            // tslint:disable-next-line: max-line-length
            tap((/**
             * @param {?} t
             * @return {?}
             */
            t => google.search.cse.element.render({ div: this.element.nativeElement, tag: this.googleTag, gname: this.gname, attributes: this.attributes }))), 
            // 取得 google custom search 的 element
            map((/**
             * @param {?} t
             * @return {?}
             */
            t => google.search.cse.element.getElement(this.gname))), filter((/**
             * @param {?} element
             * @return {?}
             */
            element => !isNullOrUndefined(element)))).subscribe((/**
             * @param {?} element
             * @return {?}
             */
            element => {
                this.googleElement.next(element);
                this.googleListenerSubscription.unsubscribe();
            }));
            combineLatest(this.googleElement, this._query)
                .pipe(map((/**
             * @param {?} __0
             * @return {?}
             */
            ([element, query]) => ({ element: (element), query: (query) }))), filter((/**
             * @param {?} temp
             * @return {?}
             */
            temp => !isNullOrUndefined(temp.query) && !isNullOrUndefined(temp.element)))).subscribe((/**
             * @param {?} temp
             * @return {?}
             */
            temp => {
                if (temp.query === '') {
                    temp.element.clearAllResults();
                }
                else {
                    temp.element.execute(temp.query);
                }
            }));
        }
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        if (this.googleListenerSubscription) {
            this.googleListenerSubscription.unsubscribe();
        }
    }
    /**
     * @return {?}
     */
    findGoogleElement() {
        return this.googleTag + this.element.nativeElement.children.item(0).id.replace('___gcse_', '');
    }
}
GoogleSearchResultsOnlyDirective.decorators = [
    { type: Directive, args: [{
                selector: '[tmGoogleSearchResultsOnly]'
            },] }
];
/** @nocollapse */
GoogleSearchResultsOnlyDirective.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] },
    { type: ElementRef }
];
GoogleSearchResultsOnlyDirective.propDecorators = {
    query: [{ type: Input }],
    attributes: [{ type: Input }],
    gname: [{ type: Input }]
};
if (false) {
    /**
     * 是否渲染端為瀏覽器
     * @type {?}
     * @protected
     */
    GoogleSearchResultsOnlyDirective.prototype.isBrowser;
    /** @type {?} */
    GoogleSearchResultsOnlyDirective.prototype.googleListenerSubscription;
    /** @type {?} */
    GoogleSearchResultsOnlyDirective.prototype.googleElement;
    /**
     * @type {?}
     * @private
     */
    GoogleSearchResultsOnlyDirective.prototype._query;
    /** @type {?} */
    GoogleSearchResultsOnlyDirective.prototype.attributes;
    /** @type {?} */
    GoogleSearchResultsOnlyDirective.prototype.googleTag;
    /** @type {?} */
    GoogleSearchResultsOnlyDirective.prototype.gname;
    /**
     * @type {?}
     * @protected
     */
    GoogleSearchResultsOnlyDirective.prototype.platformId;
    /**
     * @type {?}
     * @protected
     */
    GoogleSearchResultsOnlyDirective.prototype.element;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/directive/limitless-scroll.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * 原名: limitlessScroll
 * 判斷是否滾動到達底部並觸發事件
 * 在原DCM cms-object-07 中有使用 "ngx-infinite-scroll": "^0.8.3" 可在之後比較優劣後再決定使用哪種方式
 */
class LimitlessScrollDirective {
    /**
     * @param {?} platformId
     * @param {?} elementRef
     */
    constructor(platformId, elementRef) {
        this.platformId = platformId;
        this.elementRef = elementRef;
        this.touchBottom = new EventEmitter();
        this.scrollSubj = new BehaviorSubject(new Date().getTime());
        this.isBrowser = isPlatformBrowser(this.platformId);
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        if (this.isBrowser) {
            this.scrollSubj.pipe(debounceTime(300)).subscribe((/**
             * @param {?} v
             * @return {?}
             */
            v => {
                this.checkTouchBottom();
            }));
        }
    }
    /**
     * @param {?} $event
     * @return {?}
     */
    onScrollEvent($event) {
        this.scrollSubj.next(new Date().getTime());
    }
    /**
     * @return {?}
     */
    checkTouchBottom() {
        /** @type {?} */
        const rect = this.elementRef.nativeElement.getBoundingClientRect();
        if (rect.bottom < window.screen.height) {
            this.touchBottom.emit();
        }
    }
}
LimitlessScrollDirective.decorators = [
    { type: Directive, args: [{
                selector: '[tmLimitlessScroll]',
            },] }
];
/** @nocollapse */
LimitlessScrollDirective.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] },
    { type: ElementRef }
];
LimitlessScrollDirective.propDecorators = {
    touchBottom: [{ type: Output, args: ['tmLimitlessScroll',] }],
    onScrollEvent: [{ type: HostListener, args: ['window:scroll', ['$event'],] }]
};
if (false) {
    /** @type {?} */
    LimitlessScrollDirective.prototype.touchBottom;
    /** @type {?} */
    LimitlessScrollDirective.prototype.scrollSubj;
    /**
     * 是否渲染端為瀏覽器
     * @type {?}
     * @protected
     */
    LimitlessScrollDirective.prototype.isBrowser;
    /**
     * @type {?}
     * @protected
     */
    LimitlessScrollDirective.prototype.platformId;
    /**
     * @type {?}
     * @protected
     */
    LimitlessScrollDirective.prototype.elementRef;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/component/list-filter/list-filter.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * 原名: list-filter-01
 */
class ListFilterComponent {
    constructor() {
        /**
         * 可篩選項目列表
         */
        this._options = new BehaviorSubject([]);
        /**
         * 是否有全部取消按鈕
         */
        this.hasCancelAll = false;
        /**
         * 篩選項目有變動
         */
        this.filterConditionChange = new EventEmitter();
        /**
         * 選中的項目列表
         */
        this.filterValues = [];
        /**
         * 是否全選
         */
        this.isAllCheck = false;
        /**
         *
         */
        this.i18nLanguageWords = {
            filterBy: 'Filter',
            all: 'All',
            cancelAll: 'Cancel All'
        };
        this.idName = 'tmListFilter' + ListFilterComponent.compCount++;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set options(value) {
        if (this.options.length > 0) {
            if (!value) {
                value = [];
            }
            this._options.next(value);
        }
        else {
            if (value && value.length > 0) {
                this._options.next(value);
            }
        }
    }
    /**
     * @return {?}
     */
    get options() {
        return this._options.getValue();
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this._options.pipe(debounceTime(300), distinctUntilChanged((/**
         * @param {?} x
         * @param {?} y
         * @return {?}
         */
        (x, y) => JSON.stringify(x) === JSON.stringify(y)))).subscribe((/**
         * @param {?} v
         * @return {?}
         */
        v => {
            /** @type {?} */
            let hasChange = false;
            if (this.filterValues && this.filterValues.length > 0) {
                this.filterValues = [];
                if (this.keep && this.keep.length > 0 && v.length > 0) {
                    this.setDefaultSelection(v);
                }
                hasChange = true;
            }
            else {
                if (this.keep && this.keep.length > 0 && v.length > 0) {
                    hasChange = this.setDefaultSelection(v);
                }
            }
            if (hasChange) {
                this.filterConditionChange.emit(this.filterValues);
            }
        }));
    }
    /**
     * 設定預設選好的選項
     * @param {?} options
     * @return {?}
     */
    setDefaultSelection(options) {
        /** @type {?} */
        let hasChange = false;
        this.keep.forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => {
            /** @type {?} */
            const d = options.find((/**
             * @param {?} opt
             * @return {?}
             */
            opt => opt.value === val));
            if (d) {
                if (d.checked !== true) {
                    hasChange = true;
                }
                d.checked = true;
                this.filterValues.push(d.value);
            }
        }));
        this.isAllCheck = this.filterValues.length === options.length && this.filterValues.length !== 0;
        this.keep = undefined;
        return hasChange;
    }
    /**
     * 選擇單項
     * @param {?} data
     * @return {?}
     */
    toggleOne(data) {
        this._toggleData(data);
        this.filterConditionChange.emit(this.filterValues);
    }
    /**
     * 選擇全部
     * @return {?}
     */
    toggleAll() {
        if (this.isAllCheck) {
            from(this.options).pipe(filter((/**
             * @param {?} data
             * @return {?}
             */
            (data) => data.checked === true))).subscribe((/**
             * @param {?} data
             * @return {?}
             */
            (data) => this._toggleData(data)));
        }
        else {
            from(this.options).pipe(filter((/**
             * @param {?} data
             * @return {?}
             */
            (data) => data.checked === false))).subscribe((/**
             * @param {?} data
             * @return {?}
             */
            (data) => this._toggleData(data)));
        }
        this.filterConditionChange.emit(this.filterValues);
    }
    /**
     * @private
     * @param {?} data
     * @return {?}
     */
    _toggleData(data) {
        data.checked = !data.checked;
        if (data.checked) {
            this.filterValues.push(data.value);
        }
        else {
            this.filterValues.splice(this.filterValues.findIndex((/**
             * @param {?} value
             * @return {?}
             */
            (value) => value === data.value)), 1);
        }
        this.isAllCheck = this.filterValues.length === this.options.length && this.filterValues.length !== 0;
    }
    /**
     * @return {?}
     */
    cleanAllSelected() {
        this.options.forEach((/**
         * @param {?} option
         * @return {?}
         */
        option => {
            option.checked = false;
        }));
        this.filterValues = [];
        this.isAllCheck = false;
    }
}
/**
 * 計算組件建立的次數，用來產生唯一的組件識別碼作為 dom id 用
 */
ListFilterComponent.compCount = 0;
ListFilterComponent.decorators = [
    { type: Component, args: [{
                selector: 'tm-list-filter',
                template: "<dl class=\"dl-horizontal\" *ngIf=\"options?.length > 0\">\r\n  <dt class=\"dl-horizontal-dt\"><label for=\"{{idName}}\" (click)=\"filterList.focus()\">{{filterLabel}}</label></dt>\r\n  <dd class=\"dl-horizontal-dd\">\r\n    <ul id=\"{{idName}}\" attr.aria-label=\"{{ i18nLanguageWords.filterBy }}\" role=\"listbox\" tabindex=\"-1\" #filterList>\r\n      <!-- <a role=\"button\" title=\"{{ i18nLanguageWords.all }}\" href=\"javascript: void(0)\"\r\n          role=\"option\" aria-disabled=\"false\" [class.active]=\"isAllCheck\" [attr.aria-selected]=\"isAllCheck\"\r\n          (click)=\"toggleAll()\"><li><span>{{ i18nLanguageWords.all }}</span></li></a>\r\n      <a role=\"button\" title=\"{{data.label}}\" href=\"javascript: void(0)\" *ngFor=\"let data of options\"\r\n          role=\"option\" aria-disabled=\"false\" [class.active]=\"data.checked\" [attr.aria-selected]=\"data.checked\"\r\n          (click)=\"toggleOne(data)\"><li><span>{{data.label}}</span></li></a> -->\r\n      <li role=\"option\">\r\n        <a role=\"button\" title=\"{{ i18nLanguageWords.all }}\" href=\"javascript: void(0)\" [class.active]=\"isAllCheck\" [attr.aria-selected]=\"isAllCheck\"\r\n        (click)=\"toggleAll()\">{{ hasCancelAll ? ( isAllCheck ? i18nLanguageWords.cancelAll : i18nLanguageWords.all) : i18nLanguageWords.all }}</a>\r\n      </li>\r\n      <li role=\"option\" *ngFor=\"let data of options\">\r\n        <a role=\"button\" title=\"{{data.label}}\" href=\"javascript: void(0)\" [class.active]=\"data.checked\"  [attr.aria-selected]=\"data.checked\"\r\n        (click)=\"toggleOne(data)\">{{data.label}}</a>\r\n      </li>\r\n    </ul>\r\n  </dd>\r\n</dl>\r\n",
                encapsulation: ViewEncapsulation.None,
                styles: [".dl-horizontal-dd ul li{display:inline-block;margin-right:15px;margin-bottom:10px;list-style-type:none}.dl-horizontal-dd ul li a{border-radius:0;padding:5px 15px;display:block;font-size:medium;color:#333;background:#fff;border:1px solid #d4d4d4}.dl-horizontal-dd ul li a.active{color:#fff!important;background:#f15f74;border:1px solid #f15f74}"]
            }] }
];
/** @nocollapse */
ListFilterComponent.ctorParameters = () => [];
ListFilterComponent.propDecorators = {
    filterLabel: [{ type: Input }],
    options: [{ type: Input }],
    keep: [{ type: Input }],
    hasCancelAll: [{ type: Input }],
    filterConditionChange: [{ type: Output }],
    i18nLanguageWords: [{ type: Input }]
};
if (false) {
    /**
     * 計算組件建立的次數，用來產生唯一的組件識別碼作為 dom id 用
     * @type {?}
     */
    ListFilterComponent.compCount;
    /** @type {?} */
    ListFilterComponent.prototype.idName;
    /**
     * 篩選器標籤
     * @type {?}
     */
    ListFilterComponent.prototype.filterLabel;
    /**
     * 可篩選項目列表
     * @type {?}
     */
    ListFilterComponent.prototype._options;
    /**
     * 從網址保存來的查詢參數
     * @type {?}
     */
    ListFilterComponent.prototype.keep;
    /**
     * 是否有全部取消按鈕
     * @type {?}
     */
    ListFilterComponent.prototype.hasCancelAll;
    /**
     * 篩選項目有變動
     * @type {?}
     */
    ListFilterComponent.prototype.filterConditionChange;
    /**
     * 選中的項目列表
     * @type {?}
     */
    ListFilterComponent.prototype.filterValues;
    /**
     * 是否全選
     * @type {?}
     */
    ListFilterComponent.prototype.isAllCheck;
    /**
     *
     * @type {?}
     */
    ListFilterComponent.prototype.i18nLanguageWords;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/directive/close-on-container-blur.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * 當焦點移出容器就自動關閉容器，
 * 必須帶入tmCloseOnContainerBlur屬性，必須提供 [closeContainer], [listenOnOpen] and [listenOnClose]。
 *
 * \@usageNotes 將此指令放在容器開關上並餵入容器參考 tmCloseOnContainerBlur: HTMLElement
 * 詳細使用方式請查看 demo 檔案
 *
 *
 * ```html
 * <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-expanded="false"
 *   (click)="toggleMenu($event)"
 *   tmCloseOnContainerBlur="container"
 *   [listenOnOpen]="listenOnOpen"
 *   [listenOnClose]="listenOnClose"
 *   [closeContainer]="closeDpMenu"
 *   #ccb="tmCCB">下拉選單按鈕<span class="caret></span>
 * </a>
 * <ul #container>...</ul>
 * ```
 *
 * ```typescript
 * closeContainer = (toggler?: HTMLElement, container?: HTMLElement) => {
 *   $(toggler).dropdown('toggle');
 * };
 *
 * listenOnOpen = (cb: () => void) => {
 *   $(ccb.toggler.nativeElement.parentElement).on('shown.bs.dropdown', (e) => {
 *     e.stopPropagation();
 *     cb();
 *   });
 * };
 *
 * listenOnClose = (cb: () => void) => {
 *   $(ccb.toggler.nativeElement.parentElement).on('hide.bs.dropdown.sub', (e) => {
 *     e.stopPropagation();
 *     cb();
 *   });
 * }
 * ```
 */
class CloseOnContainerBlurDirective {
    /**
     * @param {?} el
     */
    constructor(el) {
        /**
         * 是否容器已打開
         */
        this.isOpened = false;
        /**
         * 容器打開後處理，開啟聚焦監聽
         */
        this.onOpenHandler = (/**
         * @return {?}
         */
        () => {
            this.isOpened = true;
            document.body.addEventListener('focusin', this.handleFocusInEventHandler);
        });
        /**
         * 容器關閉後處理，關閉聚焦監聽
         */
        this.onCloseHandler = (/**
         * @return {?}
         */
        () => {
            this.isOpened = false;
            document.body.removeEventListener('focusin', this.handleFocusInEventHandler);
        });
        /**
         * 全局監聽焦點事件
         */
        this.handleFocusInEventHandler = (/**
         * @param {?} event
         * @return {?}
         */
        (event) => {
            if (this.isOpened) {
                /** @type {?} */
                const tg = (/** @type {?} */ (event.target));
                // 焦點在開關上
                if (this.toggler.nativeElement === tg) {
                    return;
                }
                // 焦點在容器內
                /** @type {?} */
                let find = closest(tg, (/** @type {?} */ (this.tmCloseOnContainerBlur)));
                if (find) {
                    return;
                }
                // 焦點在開關內
                find = closest(tg, (/** @type {?} */ (this.toggler.nativeElement)));
                if (find) {
                    return;
                }
                // 焦點在開關和容器以外
                this.close();
            }
        });
        this.toggler = el;
    }
    /**
     * 內部呼叫的關閉容器方法
     * @private
     * @return {?}
     */
    close() {
        if (this.isOpened) {
            if (!this.closeContainer) {
                throw new Error('[closeContainer] not set');
            }
            this.closeContainer(this.toggler.nativeElement, this.tmCloseOnContainerBlur);
        }
    }
    /**
     * 監聽容器打開
     * @param {?} func
     * @return {?}
     */
    set listenOnOpen(func) {
        this._listenOnOpen = func;
        if (this._listenOnOpen) {
            this._listenOnOpen(this.onOpenHandler);
        }
    }
    /**
     * @return {?}
     */
    get listenOnOpen() { return this._listenOnOpen; }
    /**
     * 監聽容器關閉
     * @param {?} func
     * @return {?}
     */
    set listenOnClose(func) {
        this._listenOnClose = func;
        if (this._listenOnClose) {
            this._listenOnClose(this.onCloseHandler);
        }
    }
    /**
     * @return {?}
     */
    get listenOnClose() { return this._listenOnClose; }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
    }
}
CloseOnContainerBlurDirective.decorators = [
    { type: Directive, args: [{
                selector: '[tmCloseOnContainerBlur]',
                exportAs: 'tmCCB'
            },] }
];
/** @nocollapse */
CloseOnContainerBlurDirective.ctorParameters = () => [
    { type: ElementRef }
];
CloseOnContainerBlurDirective.propDecorators = {
    tmCloseOnContainerBlur: [{ type: Input }],
    closeContainer: [{ type: Input }],
    listenOnOpen: [{ type: Input }],
    listenOnClose: [{ type: Input }]
};
if (false) {
    /**
     * 要被觀察的容器
     * @type {?}
     */
    CloseOnContainerBlurDirective.prototype.tmCloseOnContainerBlur;
    /**
     * 是否容器已打開
     * @type {?}
     */
    CloseOnContainerBlurDirective.prototype.isOpened;
    /**
     * 切換容器開關的元素
     * @type {?}
     */
    CloseOnContainerBlurDirective.prototype.toggler;
    /**
     * 關閉容器，組件應提供此方法
     * @type {?}
     */
    CloseOnContainerBlurDirective.prototype.closeContainer;
    /**
     * 容器打開後處理，開啟聚焦監聽
     * @type {?}
     * @private
     */
    CloseOnContainerBlurDirective.prototype.onOpenHandler;
    /**
     * 監聽容器打開方法，組件應提供此方法
     * @type {?}
     * @private
     */
    CloseOnContainerBlurDirective.prototype._listenOnOpen;
    /**
     * 容器關閉後處理，關閉聚焦監聽
     * @type {?}
     * @private
     */
    CloseOnContainerBlurDirective.prototype.onCloseHandler;
    /**
     * 監聽容器關閉方法，組件應提供此方法
     * @type {?}
     * @private
     */
    CloseOnContainerBlurDirective.prototype._listenOnClose;
    /**
     * 全局監聽焦點事件
     * @type {?}
     */
    CloseOnContainerBlurDirective.prototype.handleFocusInEventHandler;
}
/** @type {?} */
const closest = (/**
 * @param {?} el
 * @param {?} s
 * @return {?}
 */
(el, s) => {
    do {
        if (typeof s === 'string') {
            if (Element.prototype.matches.call(el, s)) {
                return el;
            }
        }
        else if (s instanceof HTMLElement) {
            if (el === s) {
                return el;
            }
        }
        el = el.parentElement || el.parentNode;
    } while (el !== null && el.nodeType === 1);
    return null;
});
const ɵ0 = closest;

/**
 * @fileoverview added by tsickle
 * Generated from: lib/pipe/currency.pipe.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class TmCurrencyPipe {
    /**
     * @param {?} value
     * @return {?}
     */
    transform(value) {
        return currencyCommaNum(value);
    }
}
TmCurrencyPipe.decorators = [
    { type: Pipe, args: [{
                name: 'tmCurrency'
            },] }
];
/**
 * 將數字轉成千分位字串
 * @param {?=} num
 * @return {?}
 */
function currencyCommaNum(num = 0) {
    // tslint:disable-next-line: no-construct
    return new Number(num).toLocaleString();
    // safari 不支援 Lookbehind assertion，故以下方法不行用
    // return `${num}`.replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',');
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/techmore-shared.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class TechmoreSharedModule {
}
TechmoreSharedModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule,
                ],
                declarations: [
                    SafePipe,
                    MouseOverScrollDirective,
                    ContenteditableModelDirective,
                    ComponentOutletDirective,
                    RecaptchaComponent,
                    OffCanvasBtnDirective,
                    ErrorDefaultImageDirective,
                    FontAdjustDirective,
                    ObjectFitDirective,
                    PrinterDirective,
                    ShareFacebookDirective,
                    ShareLineDirective,
                    ShareTwitterDirective,
                    TextEllipsisDirective,
                    GoogleSearchBoxDirective,
                    GoogleSearchResultsOnlyDirective,
                    LimitlessScrollDirective,
                    ListFilterComponent,
                    CloseOnContainerBlurDirective,
                    TmCurrencyPipe,
                ],
                exports: [
                    SafePipe,
                    MouseOverScrollDirective,
                    ContenteditableModelDirective,
                    ComponentOutletDirective,
                    RecaptchaComponent,
                    OffCanvasBtnDirective,
                    ErrorDefaultImageDirective,
                    FontAdjustDirective,
                    ObjectFitDirective,
                    PrinterDirective,
                    ShareFacebookDirective,
                    ShareLineDirective,
                    ShareTwitterDirective,
                    TextEllipsisDirective,
                    GoogleSearchBoxDirective,
                    GoogleSearchResultsOnlyDirective,
                    LimitlessScrollDirective,
                    ListFilterComponent,
                    CloseOnContainerBlurDirective,
                    TmCurrencyPipe,
                ]
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/FilterItem.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FilterItem {
    constructor() {
        this.checked = false;
    }
}
if (false) {
    /** @type {?} */
    FilterItem.prototype.label;
    /** @type {?} */
    FilterItem.prototype.value;
    /** @type {?} */
    FilterItem.prototype.checked;
}

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: techmore-share.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { CloseOnContainerBlurDirective, ComponentOutletDirective, ContenteditableModelDirective, ErrorDefaultImageDirective, FilterItem, FontAdjustDirective, GoogleSearchBoxDirective, GoogleSearchResultsOnlyDirective, LimitlessScrollDirective, ListFilterComponent, ObjectFitDirective, OffCanvasBtnDirective, PrinterDirective, RecaptchaComponent, SafePipe, ShareFacebookDirective, ShareLineDirective, ShareTwitterDirective, TechmoreSharedModule, TextEllipsisDirective, TmCurrencyPipe, MouseOverScrollDirective as ɵa };
//# sourceMappingURL=techmore-share.js.map
